export default {
  FormatCNH(value) {
    if (!value) {
      return ''
    }
    value = value.toString().toUpperCase()
    const regex = /([0-9A-Z]{1})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{1})/
    const subst = '$1 $2 $3 $4 $5'
    return value.replace(regex, subst)
  },
  FormatRNE(value) {
    if (!value) {
      return ''
    }
    value = value.toString().toUpperCase()
    const regex = /([A-Z]{1})([0-9]{6})([0-9A-Z]{1})/
    const subst = '$1$2-$3'
    return value.replace(regex, subst)
  },
  ObterTipoArquivo(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return null;
    }

    const extension = fileName.slice(lastDotIndex + 1).toLowerCase();
 
    switch (extension) {
      case 'png':
        return 'image/png'
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg'
      case 'pdf':
        return 'application/pdf'
      default:
        return null
    }
  },
  AjustarSituacaoOnboardingConta(response) {
    const situacaoAguardandoAnalisePendenciado = 8
    const situacaoAguardandoAnaliseOnboarding = 6

    const situacaoAguardandoAnaliseRecusada = 7
    const situacaoAguardandoAnaliseCancelada = 5

    for (let count = 0; response.length > count; count++) {
      if (response[count].situacaoSolicitacaoConta == situacaoAguardandoAnalisePendenciado) {
        response[count].situacao = situacaoAguardandoAnaliseOnboarding
        continue
      }

      if (response[count].situacaoSolicitacaoConta ==  situacaoAguardandoAnaliseRecusada) {
        response[count].situacao = situacaoAguardandoAnaliseCancelada
        continue
      }

      if (response[count].situacaoSolicitacaoConta ==  situacaoAguardandoAnaliseCancelada) {
        response[count].situacao = situacaoAguardandoAnaliseRecusada
        continue
      }
    }

    return response
  },
  FormatarDataHora(dataIso) {
    if (!dataIso) return "";

    const data = new Date(dataIso);

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();

    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    const segundos = String(data.getSeconds()).padStart(2, '0');

    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
  }
}
